/**
 * common
 */
import http from '@/request/http'

export default {
    //视频播放
    videoGetExeStatus: params => http.get(`http://127.0.0.1:8888/health`, params),//检查程序运行状态接口

    //svg获取url
    svgGetStationAttrs: params => http.get(`/api/juji/photovoltaic/getStationAttrs`, params),
    //svg获取遥测值
    svgGetData: params => http.post(`/api/plugins/telemetry/juji/values/timeseries`, params),


    /****       工作台      ***** */
    controlGetPlanList: params => http.get(`/api/plugins/statistics/getBaseAttribute`, params),//获取项目中计划列表
    controlGetWorkOrder: params => http.get(`/api/odoo/workOrder/findWorkOrderProcess`, params),//工单流程
    controlGetMonitoring: params => http.get(`/api/plugins/statistics/getEquipmentMonitoring`, params),//设备监控
    controlGetPlanTalbeData: params => http.get(`/api/odoo/inspectionPlan/plan/findUserPlansPage`, params),//计划table数据
    controlGetECRanking: params => http.get(`/api/juji/additionalEnergyDevice/getRankingForThisMonth`, params),//能耗排行
    controlGetECData: params => http.get(`/api/juji/additionalEnergyDevice/getRealTimeEnergyConsumption`, params),//实时能耗监测

    /****       顶部今日计划      ***** */
    headerGetPlanTolData: params => http.get(`/api/odoo/inspectionTask/plan/getTopPlanStatistics`, params),


    /****       人员查询      ***** */
    publicGetAdminUser: params => http.get(`/api/juji/buildingSystem/getUsers`, params),



}